<template>
  <client-only>
    <v-container id="companies-board">
      <v-row class="companies-board-row">
        <v-col
          v-for="(i, key) in DfpHomePage"
          :key="key"
          text-center
          class="company-dfp"
          d-flex
        >
          <GptAd
            :ad-unit="`3177829/${i.adunit}`"
            :id="i.id"
            :size="[120, 38]"
          />
        </v-col>
      </v-row>
    </v-container>
  </client-only>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      DfpHomePage: {
        1: {
          adunit: 'Logo1newsite',
          id: '1585493459494-0',
        },
        2: {
          adunit: 'Logo2newsite',
          id: '1585493765398-0',
        },
        3: {
          adunit: 'Logo3newsite',
          id: '1585493850505-0',
        },
        4: {
          adunit: 'Logo4newsite',
          id: '1585494035449-0',
        },
        5: {
          adunit: 'Logo5newsite',
          id: '1585494121594-0',
        },
        6: {
          adunit: 'Logo6newsite',
          id: '1585494224909-0',
        },
        7: {
          adunit: 'Logo13newsite',
          id: '1646729332662-0',
        },
        8: {
          adunit: 'Logo14newsite',
          id: '1646729483597-0',
        },
      },
    };
  },
};
</script>

<style lang="sass" scoped>
#companies-board
  max-width: 1260px
  background-color: #EEEEEE
  min-height: 62px
  overflow: auto
  padding: 0 12px
  @media only screen and (min-width:600px)
    padding: 0 12px
    min-height: 62px
  @media only screen and (min-width:959px)
    padding: 15px
    min-height: 86px
  .row
    max-width: 1260px
    flex-wrap: nowrap
    margin: auto
  .company-dfp
    text-align: center
::-webkit-scrollbar
  display: none
</style>
